import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';

import { Account } from './types';

export async function getAccountsRequest(
  search: string,
  page: string,
  size: string,
) {
  try {
    const response = await api().get('/accounts', {
      params: {
        search,
        page,
        size,
      },
    });

    return response?.data;
  } catch (error) {
    return null;
  }
}

export async function getAccountByIdRequest(accountId: string) {
  try {
    const response = await api().get(`/accounts/${accountId}`);

    return response;
  } catch (error) {
    toast.error('Ocorreu um erro ao listar. Tente novamente mais tarde.');

    return null;
  }
}

export async function getAccountByUserIdRequest(
  userId: string,
  search: string,
  page: string,
  size: string,
) {
  try {
    const response = await api().get(`/accounts/user/${userId}`, {
      params: {
        search,
        page,
        size,
      },
    });

    return response;
  } catch (error) {
    toast.error('Ocorreu um erro ao listar. Tente novamente mais tarde.');

    return null;
  }
}

export async function createAccountRequest(
  account: Partial<Account>,
  userId: string,
) {
  try {
    const response = await api().post(
      '/accounts',
      {
        ...account,
      },
      {
        headers: {
          userId,
        },
      },
    );

    toast.success('Conta criada com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function updateAccountRequest(
  account: Partial<Account>,
  accountId: string,
  userId: string,
) {
  try {
    const response = await api().patch(
      `/accounts/${accountId}`,
      {
        ...account,
      },
      {
        headers: {
          userId,
        },
      },
    );

    toast.success('Conta editada com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function addAdminRequest(
  accountId: string,
  adminName: string,
  adminEmail: string,
  adminDoc: string,
  userId: string,
) {
  try {
    const response = await api().patch(
      `/accounts/new-admin/${accountId}`,
      {},
      {
        headers: {
          adminName,
          adminEmail,
          adminDoc,
          userId,
        },
      },
    );

    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function removeAdminRequest(accountId: string, adminId: string) {
  try {
    const response = await api().patch(
      `/accounts/remove-admin/${accountId}`,
      {},
      {
        headers: {
          adminId,
        },
      },
    );
    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function removeAccountRequest(accountId: string) {
  try {
    const response = await api().patch(`/accounts/remove/${accountId}`);

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function deleteAccountRequest(accountId: string) {
  try {
    const response = await api().delete(`/accounts/${accountId}`);

    return response.data;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}
